/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { table, tableCard } from './TableContainer.style'

export function TableContainer ({ card = false, ...other }) {
  return <table css={[table, card && tableCard]} {...other} />
}
